/* RESPONSIBLE TEAM: team-ai-agent-2 */

export interface CustomAnswerWireFormat {
  id: number;
  title?: string;
  deleted: boolean;
}

export class CustomAnswer {
  constructor(
    public id: number,
    public deleted: boolean,
    public title?: string,
  ) {
    this.id = id;
    this.deleted = deleted;
    this.title = title;
  }

  static deserialize(data: CustomAnswerWireFormat): CustomAnswer {
    return new CustomAnswer(data.id, data.deleted, data.title);
  }
}
